// 公共路由

const constantRoutes = [
	{
		path: '/',
		name: 'login',
		hidden: true,
		redirect: '',
		component: () => import('@/views/login'),
		meta: {
			title: '登录',
		},
	},
	{
		path: '/404',
		name: '404',
		component: () => import('@/views/error/404'),
		hidden: true,
		meta: {
			title: '404',
		},
	},
];

export default constantRoutes;
